module.exports = __webpack_public_path__ + "static/img/manual_ja_20.7565e1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_20.png
// module id = LOKO
// module chunks = 4